import React, { ReactElement } from 'react';
import { Button, LinkButton, Text, Modal } from '@feast-it/ui/light';

import { PATHS } from '../../../../constants/paths';
import { Container, ButtonWrapper } from './EnquiryModal.styled';

interface EnquiryModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function EnquiryModal({
  isOpen,
  onClose,
}: EnquiryModalProps): ReactElement {
  return (
    <Modal open={isOpen} handleClose={onClose} disableFullscreenOnMobile>
      <Container>
        <Text style="headingBoldExtraSmall">
          This supplier&apos;s profile isn&apos;t quite ready yet!
        </Text>
        <Text style="bodyMedium">
          If you&apos;d like to book, click &apos;Enquire now&apos; and
          we&apos;ll help you find a show-stopping supplier
        </Text>

        <ButtonWrapper>
          <LinkButton
            variant="solid"
            color="mediumBlue"
            href={PATHS.enquiryForm}
          >
            Enquire Now
          </LinkButton>

          <Button variant="outline" color="black" onClick={onClose}>
            Continue Browsing
          </Button>
        </ButtonWrapper>
      </Container>
    </Modal>
  );
}
